/* eslint-disable */

<template>
    <div>
        <BasicCard v-if="clientLoading" v-bind:title="`Caricamento in corso`" class="pr-2">
            <v-card-text text-center>
                <v-progress-circular
                indeterminate
                size="64"
                width="7"
                color="primary"
                ></v-progress-circular>
            </v-card-text>
        </BasicCard>
        <div v-else>
        <v-hover><v-chip 
            slot-scope="{ hover }"
            :class="`caption font-weight-thin text-uppercase mb-2 ml-2 text-center elevation-${hover ? 3 : 0}`"
            @click="goBack" absolute top left>
            <v-icon>keyboard_arrow_left</v-icon>back</v-chip></v-hover>

        <!-- CLIENT registry -->
        <BasicCard :show_title="false">
            <ClientRegistry 
                @registry_update="updateRegistry"
                :o_data="registry_data"
                :locations="locations"
                :key="updateLocationTS"
                >
            </ClientRegistry>
            <div class="pa-4">
                <v-alert
                    v-if="error_registry"
                    dense
                    type="warning"
                    >
                    <div class="d-flex flex-column">
                        <div class="font-weight-bold">Salvataggio fallito</div>
                        <div>Riprovare oppure segnalare il problema all'amministratore di sistema.</div>
                    </div>
                </v-alert>
            </div>
            <div>&nbsp;
                <AuthorInfo
                    :key="client.updated"
                    :created="client.created"
                    :created_by="client.created_by"
                    :updated="client.updated"
                    :updated_by="client.updated_by"/>
            </div>
        </BasicCard>
        
        <!-- CONTACT MANAGEMENT -->
        <BasicCard v-bind:title="`Rubrica`" v-on:header_click="toggleContacts" >
            <template v-slot:action>
                <v-btn text @click.stop="editContact(null,-1)" class="suggestion white--text"><v-icon small class="ma-1">add_box</v-icon>contatto</v-btn>
                <div @click.stop="toggleContacts" class="ml-6 cursor_pointer">
                    <v-icon class="white--text" v-if="show_contacts">expand_less</v-icon><v-icon class="white--text" v-else>expand_more</v-icon>
                </div>
            </template>
            <div v-if="show_contacts">
                <v-card class="elevation-1 ma-0 pa-0 mt-0" v-for="(contact, idx) in contacts" :key="contact.id" style="position: relative;" >
                    <v-container class="py-1">
                        <v-row no-gutters class="d-flex align-start">
                            <v-col cols="10" class="d-flex align-start justify-center pb-1 flex-grow-1">
                                <v-icon class="d-flex flex-shrink-1 flex-grow-0 pr-2" small>contacts</v-icon>
                                <div class="d-flex flex-shrink-0 flex-grow-1">
                                    <b>{{ contact.name }}</b> - 
                                    <i>email: <b>{{ contact.email }}</b></i>,
                                    <i>telefono: <b>{{ contact.phone }}</b></i>
                                </div>    
                            </v-col>
                            <v-col cols="2" class="d-flex align-start justify-end">
                                <v-btn color="action" class="ma-1" small fab @click.stop="editContact(contact.id, idx)"><v-icon>edit</v-icon></v-btn>
                                <v-btn color="action" class="ma-1" small fab @click.stop="openDeleteContactConfirm(idx, contact.id)" :disabled="contacts.length==1"><v-icon>delete</v-icon></v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card>
            </div>
        </BasicCard>
        <!-- DETAIL MANAGEMENT -->
        <BasicCard v-bind:title="`Sedi registrate: ${locations.length}`" v-on:header_click="toggleLocations" :key="show_locations">
            <template v-slot:action>
                <v-btn v-can="{obj_type:'location', action: 'edit'}" text @click.stop="openEdit(null)" class="suggestion white--text"><v-icon small class="ma-1">add_box</v-icon>sede</v-btn>
                <div @click.stop="toggleLocations" class="ml-6 cursor_pointer">
                    <v-icon class="white--text" v-if="show_locations">expand_less</v-icon><v-icon  class="white--text" v-else>expand_more</v-icon>
                </div>
            </template>
            <v-expansion-panels accordion v-if="show_locations">
                <LocationDetails 
                    v-for="(location) in locations" 
                    :key="location._id+'_'+location.value.updated"
                    v-bind:loc_id="location._id"
                    v-bind:contacts="Object.values(client.contacts)"
                    v-on:edit_location="openEdit"
                    v-on:remove_location="openDeleteLocationConfirm">
                </LocationDetails>
            </v-expansion-panels>
            
        </BasicCard>
        <BasicCard v-bind:title="`Strumenti`">
            <InstrumentList
                ref="cd_instrumentList"
                :client_id="client_id"
                :lock_client="true"
                :location_id="selected_location"
                :add_enabled="false"
                :show_client="false"
            ></InstrumentList>
        </BasicCard>                        

        <ConfirmDialog
                ref="locationDelete"
                v-bind:data="delete_location"
                v-on:close_dialog="closeDeleteLocation"
                v-on:confirm_result="onDeleteLocationConfirm"/>
        <LocationEdit
            ref="locationEdit"
            v-bind:client_id="client_id"
            v-bind:enable_registered="false"
            v-on:locationDialogClosed="updateLocations"
            v-on:add_contact="editContact(null, -1)"
        />
        <ConfirmDialog
                ref="contactDelete"
                v-bind:data="delete_contact_dialog"
                v-on:close_dialog="closeDeleteContactDialog"
                v-on:confirm_result="onDeleteContactConfirm"/>
        <ContactDialog
            ref="contactEdit"
            v-on:contact_update="updateContact"
        />
        </div>
    </div>
</template>

<script>
import ClientRegistry from "./ClientRegistry"
import LocationDetails from "./LocationDetails"
import BasicCard from '../../components/utils/Basic_card.vue'
import LocationEdit from "./LocationEdit"
import ConfirmDialog from '../../components/dialogs/ConfirmDialog'
import ContactDialog from "./ContactDialog"
//import InstrumentDialog from "./InstrumentDialog"
import InstrumentList from "../instruments/InstrumentList new"
import { searchDesign, orderByFields } from "../../utils/dbUtility.js"
import AuthorInfo from '../../components/utils/AuthorInfo'


// import _ from 'lodash'

export default {
    components: {ClientRegistry, AuthorInfo, LocationDetails, BasicCard, LocationEdit, ConfirmDialog, InstrumentList, ContactDialog},
    props: {
        client_id: {
            type: String,
            required: true,
        },
        back: {
            type: String,
            required: false,
            default: null
        }
    },
    data(){
        return {
            locations: [],
            clientLoading: true,
            client: {},
            contacts: [],
            registry_data: {},
            delete_location: {
                index: null,
                dialog: false,
                title: 'Elimina sede',
                message: "Sei sicuro di voler rimuovere la sede selezionata?",
                choices: [
                    {key: "cancel", val: "annulla", mod: "success"},
                    {key: "delete", val: "elimina"}
                    ]
            },
            selected_location: [],
            delete_contact_dialog: {
                dialog: false,
                id: null,
                idx: -1,
                title: 'Elimina contatto',
                message: "Sei sicuro di voler rimuovere il contatto selezionato?",
                choices: [
                    {key: "cancel", val: "annulla", mod: "success"},
                    {key: "delete", val: "elimina"}
                    ]
            },
            selected_contact: null,
            selected_contact_idx: -1,
            show_locations: false,
            show_contacts: false,
            updateLocationTS: 0,
            error_registry: false,
            error_contact: false,
            error_location: false

        }
    },
    beforeDestroy() {
        this.locations = null
        this.client = null
        this.contacts = null
        this.registry_data = null
        this.delete_location = null
        this.selected_location = null
        this.delete_contact_dialog = null
        this.selected_contact = null
        this.error_registry = false
        this.error_contact =false
        this.error_location = false
    },
    methods: {
        async saveClient() {
            console.log("SaveClient ******")
            this.error_registry = false
            this.client.updated_by = this.$store.state.user._id
            this.client.updated = (new Date()).getTime()
            let res = await this.$store.state.$pouch.put('registry', this.client)
            if (res.ok) {
                this.client._rev = res.rev
                console.log("Update cliente " , res)
                return true
            }
            return false
        },
        openEdit(location_id){
            // TODO open a new dialog to edit the location
            //console.log("DEBUG, test open and edit", location_id)
            //console.log(this.$refs.locationEdit)
            this.$refs.locationEdit.openDialog(this.client_id, location_id);
            //this.$refs.locationEdit.resetValidation();
        },
        openDeleteLocationConfirm(idx, id){
            console.log('DELETE', idx)
            //this.delete_location.message = `Sei sicuro di voler rimuovere ${this.locations[index].name}?` 
            this.delete_location.dialog = true;
            this.delete_location.index = idx;
            this.delete_location.id = id;
        },
        async onDeleteLocationConfirm(choice){
            try {
                if(choice == "delete"){
                    let loc_to_delete = await this.$store.state.$pouch.get("registry", this.delete_location.id);
                    loc_to_delete.updated_by = this.$store.state.user._id
                    loc_to_delete.updated = (new Date()).getTime()
                    //loc_to_delete._deleted = true;
                    loc_to_delete.dismissed = true
                    let res = this.$store.state.$pouch.put('registry', loc_to_delete)
                    //console.log("DEBUG, deleted location pouch", res)
                    this.updateLocations()
                }
                this.closeDeleteLocation()
            } catch(error) {
                console.log('error', error)
            }
        },
        closeDeleteLocation(){
            this.delete_location.dialog = false;
        },

        // async updateLocation(location, l_idx) {
        //     this.$set(this.locations, l_idx, location)
        // },
        createInstrument(){
            // TODO open a new dialog to edit the location
            //console.log(this.$refs.instrumentEdit)
            this.$refs.cd_instrumentList.editInstrument(null)
            //this.$refs.instrumentEdit.openDialog(this.client_id);
        },
        goBack(){
            console.log("DEBUG back", this.back)
            if(this.back != null){
                this.$router.push(this.back);
            } else {
                this.$router.push({name: "clientList"})
            }
        },
        
        async updateRegistry(data) {
            Object.assign(this.client, data)
            this.client.complete = !!this.client.registered_office
            this.error_registry = false
            try {
                await this.saveClient()
                this.initRegistryData()
            } catch(error) {
                this.error_registry = true
                console.log('error', error)
            }
        },
        toggleLocations() {
            this.show_locations=!this.show_locations
        },
        toggleContacts() {
            this.show_contacts=!this.show_contacts
        },
        initRegistryData() {
            this.$set(this.registry_data, '_id', this.client._id)
            this.$set(this.registry_data, 'name', this.client.name)
            this.$set(this.registry_data, 'piva', this.client.piva)
            this.$set(this.registry_data, 'fiscal_code', this.client.fiscal_code)
            this.$set(this.registry_data, 'pec', this.client.pec)
            this.$set(this.registry_data, 'unique_code', this.client.unique_code)
            this.$set(this.registry_data, 'is_partner', this.client.is_partner)
            this.$set(this.registry_data, 'registered_office', this.client.registered_office)
            // console.log('initCLientREgistry', this.registry_data)
        },
        /////////////// CONTACT //////////////////////
        editContact(id, idx){
            console.log('EDIT CONTACT', id, idx)
            this.selected_contact_idx = idx
            if (idx != -1) {
                console.log(this.contacts[id])
                this.selected_contact = this.client.contacts[id]
            } else {
                this.selected_contact = null
            }
            this.$refs.contactEdit.openDialog(this.selected_contact, this.selected_contact_idx)
        },
        async updateContact(contact, idx) {
            try {
                console.log("UPDATE CONTACT",contact, idx)
                let updatedContact = _.cloneDeep(contact)
                if (idx == -1) {
                    this.$set(this.contacts, this.contacts.length, updatedContact)
                    this.$set(this.client.contacts, contact.id, updatedContact)
                } else {
                    if (contact.id == this.contacts[idx].id) {
                        this.$set(this.contacts, idx, updatedContact)
                        this.client.contacts[contact.id] = updatedContact
                        //this.client.contacts[idx] = _.cloneDeep(contact)
                    }
                }
                await this.saveClient()
                this.$refs.locationEdit.getContacts()
                this.closeEditContactDialog()
            } catch(error) {
                this.error_contact = true
                console.log('error', error)
            }
        },
        async removeContact(id, idx) {
            let c_id = this.contacts[idx].id
            if (id == c_id) {
                delete this.client.contacts[id]
                await this.saveClient()
                let item = this.contacts.splice(idx, 1);
                console.log('****', idx, item)
            }
        },
        openDeleteContactConfirm(idx, id){
            this.delete_contact_dialog.id = id
            this.delete_contact_dialog.idx = idx
            this.delete_contact_dialog.message = `Sei sicuro di voler rimuovere ${this.contacts[this.delete_contact_dialog.idx].name}?` 
            this.delete_contact_dialog.dialog = true;
        },
        async onDeleteContactConfirm(choice){
            let deleted_contact = null;
            try {
                if(choice == "delete"){
                    deleted_contact = this.client.contacts[this.delete_contact_dialog.id]
                    await this.removeContact(this.delete_contact_dialog.id, this.delete_contact_dialog.idx)
                }
                this.closeDeleteContactDialog()
            } catch(error) {
                this.client.contacts[this.delete_contact_dialog.id] = deleted_contact;
                console.log('error', error)
            } 
        },
        closeEditContactDialog(){
            this.$refs.contactEdit.closeDialog()
        },
        closeDeleteContactDialog(){
            this.delete_contact_dialog.dialog = false;
        },
        async updateLocations(){
            await this.getLocations()
            this.$refs.cd_instrumentList.getLocations()
            this.updateLocationTS = (new Date()).getTime()
        },
        async getLocations(){
            let res = await searchDesign(this.$store.state.$pouch, 'registry', 'registry/searchByData', 'key', ['client', this.client_id], false)
            if (res != null) {
                res = res.map(item => { return { _id: item.id, value: item.value } })
                
                console.log('res -', res)
                this.locations = orderByFields(res, {value: ['value.name', 'value.updated'], order: ['asc', 'asc']})
            } else {
                this.locations = []
            }
        }

    },
    
    async mounted() {
        //console.log(this.client_id)
        this.clientLoading = true
        if(this.client_id != null && this.client_id != ''){
            this.client = await this.$store.state.$pouch.get('registry', this.client_id)
            this.initRegistryData()
            this.contacts = Object.values(this.client.contacts)
            await this.getLocations()
        }
        this.clientLoading = false
    }
}
</script>

<style style="css">
    /*.theme--light .active_tabs {
        background: var(--v-primary-lighten3)
    }*/
    .v-expansion-panel__header {
        padding: 0px 0px;
        vertical-align: middle;
    }
    .registered_office .v-input__control{ width: 100% !important; }
</style>